export { default } from './vehicle-info';
